/**
 * 移除对象中的无效键和空串键，常用语表单数据请求接口时处理，空串对接口来说是有效的
 * @param obj
 * @param options
 * @returns {*}
 */
const crypto = require('crypto');
export const removeEmptyProperty = (obj, options = {}) => {
        for (let key in obj) {
                let val = obj[key];
                if (options.ignores && options.ignores.indexOf(key) !== -1) continue;
                if (options.trim !== false && typeof val === 'string') {
                        val = val.trim();
                }
                if (null == val || '' === val) delete obj[key];
        }
        return obj;
};
// 常用正则验证规则
export const ValidateRegex = {
        // 数字
        Number: /^\d+$/,
        // 数字或字母
        NumberOrLetter: /^[0-9a-zA-Z]*$/g,
        // 手机/座机号
        Tel: /^[0-9#,*()-]*$/g,
        // 移动手机号
        MobileTel: /^1\d{10}$/,
        // URL地址
        URL: /^((ht|f)tps?):\/\/([\w\-]+(\.[\w\-]+)*\/)*[\w\-]+(\.[\w\-]+)*\/?(\?([\w\-.,@?^=%&:\/~+#]*)+)?/,
        // 银行卡号
        BANK_CARD: /^([1-9]{1})(\d{14}|\d{18})$/,
        // 身份证号
        IDCARD: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/,
        // 护照
        Passport: /^([a-zA-Z]|[0-9]){5,17}$/,
        // 营业执照
        License: /(^(?:(?![IOZSV])[\dA-Z]){2}\d{6}(?:(?![IOZSV])[\dA-Z]){10}$)|(^\d{15}$)/,
        // 车牌号码  6位数
        CarId: /[A-Z]{1}[A-Z_0-9]{5}/,
        // 车架号码 17位
        CarNo: /^[A-z|0-9]{17}$/,
        // 电子邮箱
        Email: /^([a-zA-Z]|[0-9])(\w|\-)+@[a-zA-Z0-9]+\.([a-zA-Z]{2,4})$/,
        // 非汉字，比如号码之类的，没有其他校验条件时
        NotCh: /^[u4E00-u9FA5]+$/
};
export const md5 = (str, digestType = 'hex') => {
        const hash = crypto.createHash('md5');
        hash.update(str);
        return hash.digest(digestType);
};

function cleanArray(actual) {
        const newArray = [];
        for (let i = 0; i < actual.length; i++) {
                if (actual[i]) {
                        newArray.push(actual[i]);
                }
        }
        return newArray;
}

export const jsonToQuery = (json) => {
        if (!json) return '';
        return cleanArray(Object.keys(json).map(key => {
                if (json[key] === undefined) return '';
                return encodeURIComponent(key) + '=' + encodeURIComponent(json[key]);
        })).join('&');
};
// 交强险下单数据转换
export const transferNumber = (obj) => {
        for (let x in obj) {
                if (typeof obj[x] === 'number') {
                        obj[x] = String(obj[x]);
                }
                if (typeof obj[x] === 'boolean') {
                        obj[x] = obj[x] ? '1' : '0';
                }
        }
};
// 把json转换成query格式
export const toString = (obj) => {
        let str = '';
        for (let x in obj) {
                if (typeof obj[x] === 'object') {
                        let s = x + '=' + JSON.stringify(obj[x]) + "&";
                        str += s;
                } else {
                        let s = x + '=' + obj[x] + "&";
                        str += s;
                }
        }
        return str.slice(0, -1);
};
// 检验输入的格式
export const checkFormat = (reg, val) => {
        return reg.test(val);
};

export const getParam = (s, name) => {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)"); //构造一个含有目标参数的正则表达式对象
  var r = ("&" + s).substr(1).match(reg); //匹配目标参数
  if (r != null) return unescape(r[2]);
  return null; //返回参数值
}
